import { useState, useEffect } from 'react';
import { useRequest } from 'src/hooks';

const useReqBalDetails = ({ open, ixReqBalSrc }) => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const req = useRequest();

  async function getReqBalDetails(token) {
    if (!open || !ixReqBalSrc || ixReqBalSrc.length === 0) return;

    setLoading(true);

    // ensure ixReqBalSrc is always an array
    const sources = Array.isArray(ixReqBalSrc) ? ixReqBalSrc : [ixReqBalSrc];

    try {
      const results = [];
      for (const src of sources) {
        const { success, error, data, isCancelled } = await req.get(
          `/trans/get/req/bal/details?ixReqBalSrc=${src}`,
          {},
          token
        );

        if (!success && isCancelled) continue;
        if (!success) {
          setError(true);
          setErrorMessage(error?.data ?? 'Something went wrong.');
        } else {
          results.push(...data); // flatten here
        }
      }

      setList(results);
      setError(false);
      setErrorMessage('');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    let token = () => null;
    getReqBalDetails(function(t) {
      token = t;
    });
    return () => token();
  }, [open, ixReqBalSrc]);

  return { list, loading, error, errorMessage };
};

export default useReqBalDetails;
